import * as Constants from 'components/landing/constants';

import PropTypes from 'prop-types';
import variables from 'styles/variables.module.scss';

const RangeIndicator = ({
    colorSchema,
    width,
    height = 10,
    range = 1,
    value = 0
}) => {
    if (typeof width === 'string') {
        width = Constants.MEDIA_QUERIES.XL;
    }
    const wrapperStyle = {
        width,
        backgroundColor: variables.grayLightColor,
        height: height,
        overflow: 'hidden',
        borderRadius: height / 2
    };
    const sliderStyle = {
        width: (value / range) * width,
        height: '100%',
        backgroundColor: colorSchema
    };
    return (
        <div style={wrapperStyle}>
            <div style={sliderStyle} />
        </div>
    );
};

RangeIndicator.propTypes = {
    colorSchema: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    range: PropTypes.number,
    value: PropTypes.number
};

export default RangeIndicator;
